/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	/**
	* Turn off all Vida level truncation for existing content so upgraded content
	* renders similarily after upgrade.
	**/

	class VIDA_ClippingUpgrade extends UpgradeBase {

		constructor() {
			super();

			this.VERSION = 1019;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}
			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			/*
			* Cycle through all widgets and, if they are live widgets, upgrade the clipping.
			*/
			_.each(spec.widgets, model => {
				if (model && WidgetUpgradeUtils.isLiveWidgetModel(model)) {
					if (!model.properties) {
						model.properties = [];
					}
					this._vidaClippingUpgrade(model);
				}
			});
			return Promise.resolve(spec);
		}

		_isLive(model) {
			return model && model.type && model.type === 'live';
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		_vidaClippingUpgrade(model) {
			// Turn off clipping/truncation for existing content.
			model.properties.push({
				id: 'widget.data.truncate',
				value: false
			});
		}

	}

	return new VIDA_ClippingUpgrade();
});
